/**
 * Created by ren on 07/07/2017.
 */
import * as ActionType from '../constants/constant_action_types';

const INITIAL_STATE = {
    taxes    : [],
    tax_rate : 0
};

export function pricebookReducer( state = INITIAL_STATE, action ){
    switch( action.type ) {

        case ActionType.SET_PRICEBOOK_TAXES: {
            return {  ...state,
                taxes    : action.taxes,
                tax_rate : action.taxRate
            };
        }

        default:
            return state;
    }
}